import { createContext } from 'react'

// const DEFAULT_VALUE = {}

export const DesignContext = createContext()

export default DesignContext